import React from 'react';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../media';
import { LM_CC_PHONE, LM_CC_PHONE_LINK } from '../../../constants';

export const Link = css`
	max-width: max-content;
	text-decoration: none;
`;

const StyledSpan = styled.span`
	display: block;
	font-weight: 700;
	font-size: 22px;
	line-height: 26px;
	letter-spacing: 0.15px;
	color: var(--text-primary);
	${media.tablet} {
		font-weight: 500;
		font-size: 18px;
		line-height: 24px;
		letter-spacing: 0.12px;
	}
	${media.mobile} {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.05px;
	}
`;

type PhoneLinkProps = { className?: string; element?: string };

export const PhoneLink = ({ className = '', element = 'span' }: PhoneLinkProps) => {
	if (element === 'a') {
		return (
			<a className={Link} href={LM_CC_PHONE_LINK}>
				<StyledSpan className={className}>{LM_CC_PHONE}</StyledSpan>
			</a>
		);
	}
	return (
		<span className={Link}>
			<StyledSpan className={className}>{LM_CC_PHONE}</StyledSpan>
		</span>
	);
};
